import React, { useState } from 'react'
import { Button } from 'reactstrap'
import { useResponse } from '../../../hooks/useResponse';
import { editEmployee } from '../../../api/employees';
import { useTranslation } from 'react-i18next';
 
const BlockPaymentBtn = ({employeeId, blockPayments}) => {
  const { t } = useTranslation()
  const [isPaymentBlocked, setIsPaymentBlocked] = useState(blockPayments)

  const { setData, loading, error, success } = useResponse(editEmployee, () => {
    setIsPaymentBlocked(prev => !prev)
  })

    const blockPayment = () => {
      const data = {blockPayments: true}
      setData({ type: "edit", id: employeeId, data})
    }
    
    const unBlockPayment = () => {
      const data = {blockPayments: false}
      setData({ type: "edit", id: employeeId, data })
    }

    return (
      <>
        {loading && <Button type="button">
          <i className="bx bx-hourglass bx-spin font-size-16 align-middle me-2"></i>
          {t("btns.Loading")}
        </Button>}
        
        {!loading && isPaymentBlocked && <Button color="dark" onClick={unBlockPayment}>Un Block Payment</Button>}
        
        {!loading && !isPaymentBlocked && <Button color="danger" onClick={blockPayment}>Block Payment</Button>}
      </>
  )
}

export default BlockPaymentBtn